"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint camelcase: "off" */
var config = { app_id: null };
exports.configure = function (options) {
    Object.assign(config, options);
};
var runScript = function () {
    var app_id = config.app_id;
    if (!app_id)
        return;
    /* eslint-disable */
    (function () {
        var w = window;
        var ic = w.Intercom;
        if (typeof ic === 'function') {
            ic('reattach_activator');
            ic('update', w.intercomSettings);
        }
        else {
            var d_1 = document;
            // added 'any' here
            var i = function () {
                i.c(arguments);
            };
            i.q = [];
            i.c = function (args) {
                i.q.push(args);
            };
            w.Intercom = i;
            // @ts-ignore
            function l() {
                var s = d_1.createElement('script');
                s.type = 'text/javascript';
                s.async = true;
                s.src = "https://widget.intercom.io/widget/" + app_id;
                var x = d_1.getElementsByTagName('script')[0];
                x.parentNode.insertBefore(s, x);
            }
            if (w.attachEvent) {
                w.attachEvent('onload', l);
            }
            else {
                w.addEventListener('load', l, false);
            }
        }
    })();
    /* eslint-enable */
};
exports.start = function () {
    var app_id = config.app_id;
    if (!window.Intercom || !app_id)
        return;
    window.Intercom('boot', { app_id: app_id });
};
exports.shutdown = function () {
    if (!window.Intercom)
        return;
    window.Intercom('shutdown');
};
exports.update = function (settings) {
    if (settings === void 0) { settings = {}; }
    if (!window.Intercom)
        return;
    window.Intercom('update', settings);
};
exports.init = function (app_id) {
    exports.configure({ app_id: app_id });
    runScript();
    exports.start();
};
exports.restart = function () {
    exports.shutdown();
    exports.start();
};
